module.exports = __webpack_public_path__ + "static/media/sec-3-backg-new.1537e893.png";